import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchConfig, AppConfig } from "../services/configService";

const ConfigContext = createContext<AppConfig | null>(null);

export const useConfig = () => {
  const ctx = useContext(ConfigContext);
  if (!ctx) throw new Error("useConfig must be inside ConfigProvider");
  return ctx;
};

export const ConfigProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [cfg, setCfg] = useState<AppConfig | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetchConfig()
      .then(c => { if (mounted) setCfg(c); })
      .catch(e => { if (mounted) setError((e as Error).message || "Failed to load config"); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  if (loading) return <div data-testid="config-loading">Loading configuration…</div>;
  if (error) return <div data-testid="config-error">Configuration error: {error}</div>;

  return <ConfigContext.Provider value={cfg!}>{children}</ConfigContext.Provider>;
};
